import type { Static } from '@sinclair/typebox';
import { Type } from '@sinclair/typebox';

export type Salutation = Static<typeof SalutationSchema>;
export const SalutationSchema = Type.Union([
  Type.Object({
    type: Type.Literal('PHONETIC'),
  }),
  Type.Object({
    type: Type.Literal('REPLACE'),
    salutation: Type.String(),
  }),
]);

export type SalutationOverride = Static<typeof SalutationOverrideSchema>;
export const SalutationOverrideSchema = Type.Record(Type.String(), SalutationSchema);
